<script setup lang="ts">
import {
  mdiAccountCircleOutline,
  mdiClipboardTextMultipleOutline,
  mdiLockReset,
  mdiLogout,
} from '@mdi/js'
import { useRouter } from 'vue-router'

import AppLogo from '@/components/AppLogo.vue'
import ThemeToggle from '@/components/ThemeToggle.vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const router = useRouter()

async function signOut() {
  await auth.signOut()
  await router.push({ name: 'login' })
}
</script>

<template>
  <v-app-bar flat border="b" density="comfortable" class="px-2 owner-bar">
    <router-link
      to="/surveys"
      class="text-decoration-none text-high-emphasis"
      aria-label="Survey library"
    >
      <AppLogo />
    </router-link>
    <v-btn
      to="/surveys"
      variant="text"
      class="ml-4 d-none d-sm-flex"
      :prepend-icon="mdiClipboardTextMultipleOutline"
    >
      Surveys
    </v-btn>
    <v-spacer />
    <ThemeToggle />
    <v-menu location="bottom end">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          :icon="mdiAccountCircleOutline"
          variant="text"
          aria-label="Account menu"
        />
      </template>
      <v-list density="compact" min-width="220">
        <v-list-item :subtitle="auth.email" title="Signed in as" />
        <v-divider class="my-1" />
        <v-list-item
          :prepend-icon="mdiLockReset"
          title="Change password"
          :to="{ name: 'change-password' }"
        />
        <v-list-item :prepend-icon="mdiLogout" title="Sign out" @click="signOut" />
      </v-list>
    </v-menu>
  </v-app-bar>
  <v-main>
    <div class="pa-4 pa-md-8">
      <slot />
    </div>
  </v-main>
</template>

<style scoped>
.owner-bar {
  backdrop-filter: saturate(1.4) blur(10px);
  background: rgb(var(--v-theme-surface), 0.85) !important;
}
</style>
